import { TextField, Typography, Container, InputAdornment } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { signUp } from '../../Actions/Auth';
import { useNavigate } from 'react-router-dom';
import PasswordIcon from '@mui/icons-material/Password';
import EmailIcon from '@mui/icons-material/Email';
import { color, fontFamily } from '@mui/system';
import './Signuppage.css';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import { Navbar } from '../../components/Navbar/Navbar';
import { Link } from 'react-router-dom';
const SignupPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const em = /^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@srmist.edu.in$/;
  const num = /^[0-9]+$/;

  const validate = Yup.object().shape({
    name: Yup.string().min(2, 'Too Short!').max(30, 'Too Long!').required('Required'),
    phoneNumber: Yup.string()
      .matches(phoneRegExp, 'Phone Number is not valid')
      .min(10, 'Too Short!')
      .max(10, 'Too Long!')
      .required('Required'),
    empID: Yup.string()
      .matches(num, 'Employee ID must be a number')
      .min(1, 'Too Short!')
      .max(10, 'Too Long!')
      .required('Required'),
    department: Yup.string().min(2, 'Too Short!').max(30, 'Too Long!').required('Required'),
    designation: Yup.string().min(1, 'Too Short!').max(30, 'Too Long!').required('Required'),
    email: Yup.string().matches(em, 'This is not an SRM email').email('Invalid email').required('Required'),
    altemail: Yup.string().email('Invalid email').required('Required'),

    password: Yup.string()
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character',
      )
      .required('Password is Required'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Required'),
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      empID: '',
      department: '',
      designation: '',
      email: '',
      altemail: '',
      password: '',
      confirmPassword: '',
      phoneNumber: '',
    },
    validationSchema: validate,
    onSubmit: (values, onSubmitProps) => {
      dispatch(
        signUp(
          {
            name: values.name,
            designation: values.designation,
            department: values.department,
            empID: values.empID,
            email: values.email,
            altEmail: values.altemail,
            password: values.password,
            phnNumber: values.phoneNumber,
          },
          navigate,
        ),
      );

      // setOpen(true);
      onSubmitProps.resetForm();
    },
  });

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

  const handleLogin = event => {
    event.preventDefault();
    navigate('/login');
  };

  return (
    <Container
      sx={{
        width: '100%',
        height: ['100%', '100%', '100%'],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 5,
        flexDirection: 'column',
      }}
    >
      <Navbar />

      <Container
        sx={{
          width: ['90%', '60%', '60%'],
          height: ['100%', '100%', '110%'],

          marginTop: ['0px', '0px', '60px'],
          borderRadius: 2,
          paddingBottom: 2,
          backgroundColor: '#FFFFFF',
          boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        }}
      >
        <Typography sx={{ marginTop: '20px', fontWeight: '700', fontFamily: 'poppins', px: 3 }} variant="h5">
          <span style={{ color: '#272845' }}>Start By</span> Signing Up
        </Typography>

        <form style={{ width: '100%' }} onSubmit={formik.handleSubmit}>
          <Container
            sx={{
              display: 'flex',
              flexDirection: ['column', 'column', 'row'],
              flexWrap: 'wrap',
              justifyContent: ['center', 'center', 'space-between'],
            }}
          >
            <TextField
              className="textfield"
              placeholder="  Name"
              id="name"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              InputProps={{
                disableUnderline: true,
              }}
              sx={{
                marginTop: '20px',
                backgroundColor: '#F6F7F9',
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height: '40px',
                paddingLeft: '5px',
                paddingTop: '3px',
                '& input::placeholder': {
                  fontFamily: 'poppins',
                  fontSize: '15px',
                  color: '#272845',
                  opacity: '0.7',
                },

                outlineColor: '#FF7345',
              }}
              variant="standard"
            />
            <TextField
              className="textfield"
              id="empID"
              name="empID"
              placeholder="  Employee Id"
              value={formik.values.empID}
              onChange={formik.handleChange}
              error={formik.touched.empID && Boolean(formik.errors.empID)}
              helperText={formik.touched.empID && formik.errors.empID}
              InputProps={{
                disableUnderline: true,
              }}
              sx={{
                marginTop: '20px',

                backgroundColor: '#F6F7F9',
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height: '40px',
                paddingLeft: '5px',
                paddingTop: '3px',
                '& input::placeholder': {
                  fontFamily: 'poppins',
                  fontSize: '15px',
                  color: '#272845',
                  opacity: '0.7',
                },
                outlineColor: '#FF7345',
              }}
              variant="standard"
            />
            <TextField
              className="textfield"
              id="department"
              name="department"
              placeholder="  Department"
              value={formik.values.department}
              onChange={formik.handleChange}
              error={formik.touched.department && Boolean(formik.errors.department)}
              helperText={formik.touched.department && formik.errors.department}
              // error="This is error"
              // helperText="There is error
              InputProps={{
                disableUnderline: true,
              }}
              sx={{
                marginTop: '20px',

                backgroundColor: '#F6F7F9',
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height: '40px',
                paddingLeft: '5px',
                paddingTop: '3px',
                '& input::placeholder': {
                  fontFamily: 'poppins',
                  fontSize: '15px',
                  color: '#272845',
                  opacity: '0.7',
                },
                outlineColor: '#FF7345',
              }}
              variant="standard"
            />
            <TextField
              className="textfield"
              id="designation"
              name="designation"
              placeholder="  Designation"
              value={formik.values.designation}
              onChange={formik.handleChange}
              error={formik.touched.designation && Boolean(formik.errors.designation)}
              helperText={formik.touched.designation && formik.errors.designation}
              // error="This is error"
              // helperText="There is error
              InputProps={{
                disableUnderline: true,
              }}
              sx={{
                marginTop: '20px',

                backgroundColor: '#F6F7F9',
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height: '40px',
                paddingLeft: '5px',
                paddingTop: '3px',
                '& input::placeholder': {
                  fontFamily: 'poppins',
                  fontSize: '15px',
                  color: '#272845',
                  opacity: '0.7',
                },
                outlineColor: '#FF7345',
              }}
              variant="standard"
            />
            <TextField
              className="textfield"
              id="email"
              name="email"
              placeholder="  Email Id"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              // error="This is error"
              // helperText="There is error
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <EmailIcon sx={{ mx: 1 }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                marginTop: '20px',

                backgroundColor: '#F6F7F9',
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height: '40px',
                paddingLeft: '5px',
                paddingTop: '3px',
                '& input::placeholder': {
                  fontFamily: 'poppins',
                  fontSize: '15px',
                  color: '#272845',
                  opacity: '0.7',
                },

                outlineColor: '#FF7345',
              }}
              variant="standard"
            />
            <TextField
              className="textfield"
              id="altemail"
              name="altemail"
              placeholder="  Alternate Email"
              value={formik.values.altemail}
              onChange={formik.handleChange}
              error={formik.touched.altemail && Boolean(formik.errors.altemail)}
              helperText={formik.touched.altemail && formik.errors.altemail}
              // error="This is error"
              // helperText="There is error
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <EmailIcon sx={{ mx: 1 }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                marginTop: '20px',

                backgroundColor: '#F6F7F9',
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height: '40px',
                paddingLeft: '5px',
                paddingTop: '3px',
                '& input::placeholder': {
                  fontFamily: 'poppins',
                  fontSize: '15px',
                  color: '#272845',
                  opacity: '0.7',
                },
                outlineColor: '#FF7345',
              }}
              variant="standard"
            />
            
            <TextField
              className="textfield"
              id="password"
              name="password"
              type="password"
              placeholder="Password"
              value={formik.values.password}
              onChange={formik.handleChange}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={(formik.touched.password && formik.errors.password)||("Atleast one Number,Special character, uppercase")}
              // error="This is error"
              // helperText="Atleast one Number, character, uppercase"
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <PasswordIcon sx={{ mx: 1 }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                marginTop: '20px',

                backgroundColor: '#F6F7F9',
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height: '40px',
                paddingLeft: '5px',
                paddingTop: '3px',
                '& input::placeholder': {
                  fontFamily: 'poppins',
                  fontSize: '15px',
                  color: '#272845',
                  opacity: '0.7',
                },
                outlineColor: '#FF7345',
              }}
              variant="standard"
            ></TextField>
         
           
            <TextField
              className="textfield"
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              placeholder="  Confirm Password"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
              helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
              // error="This is error"
              // helperText="There is error
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <PasswordIcon sx={{ mx: 1 }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                marginTop: '20px',

                backgroundColor: '#F6F7F9',
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height: '40px',
                paddingLeft: '5px',
                paddingTop: '3px',
                '& input::placeholder': {
                  fontFamily: 'poppins',
                  fontSize: '15px',
                  color: '#272845',
                  opacity: '0.7',
                },
                outlineColor: '#FF7345',
              }}
              variant="standard"
            />
            <TextField
              className="textfield"
              id="phoneNumber"
              name="phoneNumber"
              placeholder="  Phone Number"
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
              error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
              helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
              InputProps={{
                disableUnderline: true,
              }}
              sx={{
                marginTop: '20px',

                backgroundColor: '#F6F7F9',
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height: '40px',
                paddingLeft: '5px',
                paddingTop: '3px',
                '& input::placeholder': {
                  fontFamily: 'poppins',
                  fontSize: '15px',
                  color: '#272845',
                  opacity: '0.7',
                },
                outlineColor: '#FF7345',
              }}
              variant="standard"
            />{' '}
          </Container>

          <div className="terms-condition">
            <label className="my-4 mx-4 ">
              <Checkbox
                {...label}
                sx={{
                  fontFamily: 'poppins',
                  color: '#272845',
                  '&.Mui-checked': {
                    color: '#FF7345',
                  },
                }}
              />

              <span style={{ color: '#272845', fontSize: '15px', fontWeight: 'bold' }}>
                {' '}
                I accept{' '}
                <a
                  href="https://www.srmist.edu.in/terms-and-conditions/"
                  target="_blank"
                  style={{ color: '#FF7345', fontSize: '15px' }} rel="noreferrer"
                >
                  Terms & Conditions *
                </a>
              </span>
            </label>
          </div>
          <Button
            className="text-center"
            variant="text"
            InputProps={{
              disableElevation: true,
            }}
            sx={{
              width: '100%',
              fontFamily: 'poppins',
              color: 'white',
              marginTop: '10px',
              marginBottom: '20px',
              fontWeight: '600',
              fontSize: '18px',
              backgroundColor: '#FF7345',
              '&:hover': {
                backgroundColor: '#d95429',
              },
            }}
            type="submit"
          >
            SIGN UP
          </Button>

          <div
            className="text-center my-1 already-signup-text"
            style={{ fontSize: '15px', color: '#272845', fontFamily: 'poppins' }}
          >
            Already Signed Up?{' '}
            <span>
              <button
                onClick={handleLogin}
                style={{
                  cursor: 'pointer',
                  border: 'none',
                  fontSize: '15px',
                  color: '#FF7345',
                  backgroundColor: '#FFFFFF',
                }}
              >
                login
              </button>
            </span>
          </div>
        </form>
      </Container>
    </Container>
  );
};
export default SignupPage;
